// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11">
            <path
                fill="currentColor"
                d="M8.77957034,5.03027344 C8.63425756,5.1779294 8.44207048,5.25058579 8.2498827,5.25058579 C8.05769491,5.25058579 7.86597633,5.17734361 7.71972656,5.03085923 L5.2498827,2.56230426 L5.2498827,9.75058579 C5.2498827,10.1651952 4.91402328,10.4794922 4.52097631,10.4794922 C4.12792933,10.4794922 3.7498827,10.1654298 3.7498827,9.75058579 L3.7498827,2.56230426 L1.28027344,5.03027344 C0.987304688,5.32324219 0.512695312,5.32324219 0.219726562,5.03027344 C-0.0732421875,4.73730469 -0.0732421875,4.26269531 0.219726562,3.96972656 L3.96972656,0.219726562 C4.26269531,-0.0732421875 4.73730469,-0.0732421875 5.03027344,0.219726562 L8.78027344,3.96972656 C9.07253909,4.2638669 9.07253909,4.73730469 8.77957034,5.03027344 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(ArrowUp);
